/* eslint-disable no-param-reassign */

import { APP } from '../../reducer';
import { createAction, createReducer } from '../../../utils/reducer';

const PATH = 'invoice/';
const CONTROLS_CHANGED = `${PATH}CONTROLS_CHANGED`;

export const PAYMENT = {
  CREATE_PAYMENT: `${PATH}CREATE_PAYMENT`,
  CREATE_PAYMENT_SUCCESS: `${PATH}CREATE_PAYMENT_SUCCESS`,
  CREATE_PAYMENT_FAILED: `${PATH}CREATE_PAYMENT_FAILED`,
}

export const paymentActions = {
  fieldsChanged: createAction(CONTROLS_CHANGED, 'paymentControls'),
  createPayment: createAction(PAYMENT.CREATE_PAYMENT, 'paymentControls'),
  createPaymentSuccess: createAction(PAYMENT.CREATE_PAYMENT_SUCCESS, 'createPaymentRes'),
  createPaymentFailed: createAction(PAYMENT.CREATE_PAYMENT_FAILED, 'createPaymentRes'),
}

const initialState = {
  paymentControls: {
    effectiveDate: '',
    paymentConcept: '',
    selectedInvoices: [],
    amount: 0,
    paymentForm: '',
    destinationAccountNum: '',
    destinationRfc: '',
    sourceAccountNum: '',
    sourceRfc: '',
    sourceForeignName: '',
    loading: false,
    error: false,
    errorMessage: '',
  },
  createPaymentRes: {},
}

const payment = createReducer(initialState, {
    [CONTROLS_CHANGED](state: any, action: any) {
      state.paymentControls = {
        ...state.paymentControls,
        ...action.paymentControls,
      };
    },
    [PAYMENT.CREATE_PAYMENT]: (state: any, action: any) => {
        state.paymentControls.loading = true;
    },
    [PAYMENT.CREATE_PAYMENT_SUCCESS]: (state: any, action: any) => {
        state.paymentControls.loading = false;
        state.paymentControls.error = false;
        state.paymentControls.errorMessage = '';
        state.paymentControls.createPaymentRes = action.createPaymentRes;
    },
    [PAYMENT.CREATE_PAYMENT_FAILED]: (state: any) => {
        state.paymentControls.loading = false;
        state.paymentControls.error = true;
        state.paymentControls.errorMessage = 'Ocurrio un error al crear el complemento de pago';
    },
});

export default payment;